// extracted by mini-css-extract-plugin
export default {"titleWrapper":"Title_titleWrapper__8Nqf6","pretitle":"Title_pretitle__jJJF7","subtitle":"Title_subtitle__vg71A"};